import { Avatar, Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import moment from "moment-timezone";
import { getColorForInitial } from "nhb-toolbox";
import { getFormattedCurrency } from "src/Helpers/utils";
import { IAccountDetails } from "src/Types/account.types";
import TransactionTable from "./TransactionTable";

interface Props {
	account: IAccountDetails;
}

const SingleAccountDetails = ({ account }: Props) => {
	return (
		<div>
			<Box sx={{ mt: 3 }}>
				<Grid container spacing={3}>
					<Grid item lg={4} sm={12} md={12}>
						<Box
							sx={{
								display: "flex",
								alignItems: "center",
								// justifyContent: "center",
							}}
						>
							<Avatar
								style={{
									backgroundColor: getColorForInitial(
										account.ac_name
									),
									width: 240,
									height: 240,
									fontSize: 96,
								}}
							>
								{account.ac_name.charAt(0)}
							</Avatar>
						</Box>
					</Grid>
					<Grid item lg={8} sm={4} md={4}>
						<Grid
							container
							spacing={{ xs: 2, md: 3 }}
							columns={{ xs: 4, sm: 8, md: 12 }}
						>
							<Grid item xs={2} sm={4} md={4}>
								<Typography variant="body1" fontWeight="bold">
									Account ID:
								</Typography>
								{account.ac_id}
							</Grid>
							<Grid item xs={2} sm={4} md={4}>
								<Typography variant="body1" fontWeight="bold">
									Account Name:
								</Typography>
								{account.ac_name}
							</Grid>
							<Grid item xs={2} sm={4} md={4}>
								<Typography variant="body1" fontWeight="bold">
									Account Type:
								</Typography>
								{account.ac_type}
							</Grid>
							<Grid item xs={2} sm={4} md={4}>
								<Typography variant="body1" fontWeight="bold">
									Account Number:
								</Typography>
								{account.ac_number}
							</Grid>
							<Grid item xs={2} sm={4} md={4}>
								<Typography variant="body1" fontWeight="bold">
									Bank Name:
								</Typography>
								{account.ac_bank_name}
							</Grid>
							<Grid item xs={2} sm={4} md={4}>
								<Typography variant="body1" fontWeight="bold">
									Branch:
								</Typography>
								{account.ac_bank_branch}
							</Grid>
							<Grid item xs={2} sm={4} md={4}>
								<Typography variant="body1" fontWeight="bold">
									Opening Balance:
								</Typography>
								{getFormattedCurrency(account.opening_balance)}
							</Grid>
							<Grid item xs={2} sm={4} md={4}>
								<Typography variant="body1" fontWeight="bold">
									Current Balance:
								</Typography>
								{getFormattedCurrency(account.account_balance)}
							</Grid>
							<Grid item xs={2} sm={4} md={4}>
								<Typography variant="body1" fontWeight="bold">
									Account Created:
								</Typography>
								{moment(account.ac_created_at).format(
									"MMM Do YY, LT"
								)}
							</Grid>
							<Grid item>
								<Typography variant="body1" fontWeight="bold">
									Account Details:
								</Typography>
								{account.ac_details}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Box>
			{/* Transactions Table */}
			<TransactionTable transactions={account.transactions} />
		</div>
	);
};

export default SingleAccountDetails;
